import { render, staticRenderFns } from "./CertificateOfCompletion.vue?vue&type=template&id=fa7886f4&scoped=true&"
import script from "./CertificateOfCompletion.vue?vue&type=script&lang=js&"
export * from "./CertificateOfCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7886f4",
  null
  
)

export default component.exports